import { render, staticRenderFns } from "./detailShowTwo.vue?vue&type=template&id=04c1b1ee&scoped=true&"
import script from "./detailShowTwo.vue?vue&type=script&lang=js&"
export * from "./detailShowTwo.vue?vue&type=script&lang=js&"
import style0 from "./detailShowTwo.vue?vue&type=style&index=0&id=04c1b1ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1b1ee",
  null
  
)

export default component.exports